import { useImage } from "Context/ImageContext";
import { RoboticRabbitsS3BaseUri } from "helpers/constants";
import React from "react";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Welcome() {
  const navigate = useNavigate();
  const { handleImageLoad } = useImage();
  return (
    <section
      className="welcome-page position-relative"
      // style={{ zIndex: "99" }}
    >
      {/* <div className="welcome_banner">
      <img
        src="https://robotic-rabbits.s3.us-east-2.amazonaws.com/BG1_LoopingAnimation.gif"
        alt=""
        className="img-fluid w-100 h-100 graphic"
      />
      </div> */}


      <div className="welcome_vedio position-relative">
          <div className="logo_vedio">
                <img 
                  src="/images/dashlogo.png" 
                  className="img-fluid lazy-media"
                  onLoad={handleImageLoad}
                  onError={handleImageLoad}
                 />
          </div>
      <video autoPlay muted loop playsInline
         onLoadedData={handleImageLoad}
         onError={handleImageLoad}
         className="lazy-media"
      >
        <source 
         src={`${RoboticRabbitsS3BaseUri}/BG1_LoopingAnimation.MP4`} 
         type="video/mp4"
   
         />
       </video>
      </div>
    

      <Container className="welcome-banner h-100">
        <div className="inner-welcome h-100 position-relative justify-content-center 
        d-flex align-items-center flex-wrap mt-lg-5 py-3">
          {/* <div className="socila-list">
            <ul> */}
              {/* <li>
                <a href="javascript:void(0)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M7.12811 17.1172H8.961V10.3355H7.12811V17.1172ZM8.04455 7.3418C7.43359 7.3418 6.94482 7.83057 6.94482 8.44153C6.94482 9.05249 7.43359 9.54126 8.04455 9.54126C8.65552 9.54126 9.14428 9.05249 9.14428 8.44153C9.14428 7.83057 8.65552 7.3418 8.04455 7.3418ZM12.0769 11.3741V10.3355H10.244V17.1172H12.0769V13.6347C12.0769 11.6796 14.5818 11.5574 14.5818 13.6347V17.1172H16.4147V12.9626C16.4147 9.66345 12.9322 9.78564 12.0769 11.3741Z"
                      fill="white"
                    />
                    <circle
                      cx="11.7101"
                      cy="12.2277"
                      r="10.7101"
                      stroke="white"
                      stroke-width="2"
                    />
                  </svg>
                </a>
              </li> */}

              {/* <li>
                <a href="javascript:void(0)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M14.3129 7.90016C14.3129 7.83264 14.2861 7.76789 14.2383 7.72015C14.1906 7.67241 14.1258 7.64559 14.0583 7.64559H12.7855C12.1445 7.61366 11.517 7.83671 11.04 8.26601C10.563 8.69531 10.2753 9.29595 10.2398 9.93669V11.3114H8.96697C8.89945 11.3114 8.8347 11.3382 8.78696 11.3859C8.73922 11.4337 8.7124 11.4984 8.7124 11.5659V12.8897C8.7124 12.9572 8.73922 13.0219 8.78696 13.0697C8.8347 13.1174 8.89945 13.1442 8.96697 13.1442H10.2398V16.5554C10.2398 16.623 10.2666 16.6877 10.3144 16.7354C10.3621 16.7832 10.4269 16.81 10.4944 16.81H12.0218C12.0893 16.81 12.154 16.7832 12.2018 16.7354C12.2495 16.6877 12.2763 16.623 12.2763 16.5554V13.1442H13.6103C13.6669 13.1451 13.7222 13.127 13.7673 13.0929C13.8125 13.0587 13.845 13.0105 13.8598 12.9559L14.2263 11.6321C14.2365 11.5945 14.2378 11.5551 14.2303 11.5168C14.2228 11.4786 14.2066 11.4426 14.183 11.4116C14.1594 11.3807 14.129 11.3555 14.0941 11.3381C14.0593 11.3207 14.0209 11.3116 13.9819 11.3114H12.2763V9.93669C12.289 9.81067 12.3482 9.69389 12.4423 9.60916C12.5365 9.52443 12.6588 9.47784 12.7855 9.47847H14.0583C14.1258 9.47847 14.1906 9.45165 14.2383 9.40391C14.2861 9.35617 14.3129 9.29142 14.3129 9.2239V7.90016Z"
                      fill="white"
                    />
                    <circle
                      cx="11.7667"
                      cy="12.2277"
                      r="10.7101"
                      stroke="white"
                      stroke-width="2"
                    />
                  </svg>
                </a>
              </li> */}

            {/* <li>
              <a href="javascript:void(0)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_342_1617)">
                    <path
                      d="M17.7523 8.63234C17.3272 8.82072 16.8705 8.948 16.3904 9.00553C16.8858 8.70911 17.2564 8.24258 17.4331 7.69298C16.9676 7.96944 16.4583 8.16403 15.9271 8.26831C15.5698 7.8869 15.0967 7.63409 14.5811 7.54914C14.0654 7.46419 13.5362 7.55185 13.0755 7.7985C12.6148 8.04516 12.2484 8.43701 12.0333 8.91323C11.8181 9.38944 11.7662 9.92337 11.8855 10.4321C10.9425 10.3848 10.0199 10.1397 9.17767 9.71267C8.33546 9.28569 7.59244 8.68639 6.99684 7.95366C6.79318 8.30496 6.67608 8.71227 6.67608 9.14605C6.67585 9.53656 6.77202 9.92108 6.95604 10.2655C7.14007 10.6099 7.40626 10.9036 7.73101 11.1205C7.35439 11.1085 6.98608 11.0067 6.65673 10.8237V10.8542C6.6567 11.4019 6.84615 11.9327 7.19295 12.3567C7.53974 12.7806 8.02252 13.0714 8.55937 13.1799C8.20999 13.2745 7.8437 13.2884 7.48815 13.2207C7.63962 13.6919 7.93466 14.104 8.33197 14.3993C8.72929 14.6945 9.20898 14.8581 9.7039 14.8672C8.86375 15.5267 7.82616 15.8845 6.75805 15.8829C6.56885 15.883 6.3798 15.8719 6.19189 15.8498C7.27608 16.5469 8.53816 16.9169 9.82711 16.9154C14.1904 16.9154 16.5757 13.3016 16.5757 10.1674C16.5757 10.0656 16.5731 9.96271 16.5686 9.86088C17.0325 9.52535 17.433 9.10985 17.7513 8.63386L17.7523 8.63234Z"
                      fill="white"
                    />
                  </g>
                  <circle
                    cx="11.8243"
                    cy="12.2277"
                    r="10.7101"
                    stroke="white"
                    stroke-width="2"
                  />
                  <defs>
                    <clipPath id="clip0_342_1617">
                      <rect
                        width="12.2192"
                        height="12.2192"
                        fill="white"
                        transform="translate(5.71484 6.11914)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li> */}

              {/* <li>
                <a href="javascript:void(0)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_342_1622)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.57329 6.66056C10.1705 6.63306 10.3609 6.62695 11.8822 6.62695C13.4035 6.62695 13.5939 6.63357 14.1906 6.66056C14.7873 6.68754 15.1946 6.78275 15.551 6.92072C15.9242 7.06175 16.2628 7.28221 16.5428 7.56732C16.8279 7.84684 17.0479 8.1849 17.1884 8.55861C17.3269 8.915 17.4216 9.32231 17.4491 9.918C17.4766 10.5162 17.4827 10.7066 17.4827 12.2274C17.4827 13.7487 17.4761 13.9391 17.4491 14.5364C17.4221 15.132 17.3269 15.5393 17.1884 15.8957C17.0479 16.2695 16.8276 16.6081 16.5428 16.888C16.2628 17.1732 15.9242 17.3931 15.551 17.5336C15.1946 17.6721 14.7873 17.7668 14.1916 17.7943C13.5939 17.8218 13.4035 17.8279 11.8822 17.8279C10.3609 17.8279 10.1705 17.8213 9.57329 17.7943C8.9776 17.7673 8.5703 17.6721 8.2139 17.5336C7.84016 17.3931 7.50153 17.1728 7.2216 16.888C6.93668 16.6084 6.71619 16.2699 6.57551 15.8963C6.43753 15.5399 6.34283 15.1326 6.31534 14.5369C6.28785 13.9386 6.28174 13.7482 6.28174 12.2274C6.28174 10.7061 6.28836 10.5157 6.31534 9.91902C6.34233 9.32231 6.43753 8.915 6.57551 8.55861C6.7164 8.18495 6.93705 7.84649 7.22211 7.56682C7.50164 7.28196 7.83993 7.06147 8.21339 6.92072C8.56979 6.78275 8.9771 6.68805 9.57278 6.66056H9.57329ZM14.1453 7.66864C13.5547 7.64166 13.3775 7.63606 11.8822 7.63606C10.3869 7.63606 10.2097 7.64166 9.61911 7.66864C9.07281 7.69359 8.7765 7.78472 8.57895 7.8616C8.31777 7.96343 8.13091 8.0841 7.9349 8.28011C7.74909 8.46088 7.60609 8.68094 7.51639 8.92417C7.43951 9.12171 7.34837 9.41803 7.32343 9.96433C7.29644 10.5549 7.29084 10.7321 7.29084 12.2274C7.29084 13.7228 7.29644 13.8999 7.32343 14.4905C7.34837 15.0368 7.43951 15.3332 7.51639 15.5307C7.606 15.7736 7.74906 15.994 7.9349 16.1747C8.11564 16.3606 8.3361 16.5037 8.57895 16.5933C8.7765 16.6701 9.07281 16.7613 9.61911 16.7862C10.2097 16.8132 10.3864 16.8188 11.8822 16.8188C13.3781 16.8188 13.5547 16.8132 14.1453 16.7862C14.6916 16.7613 14.9879 16.6701 15.1855 16.5933C15.4467 16.4914 15.6335 16.3708 15.8295 16.1747C16.0154 15.994 16.1584 15.7736 16.248 15.5307C16.3249 15.3332 16.4161 15.0368 16.441 14.4905C16.468 13.8999 16.4736 13.7228 16.4736 12.2274C16.4736 10.7321 16.468 10.5549 16.441 9.96433C16.4161 9.41803 16.3249 9.12171 16.248 8.92417C16.1462 8.66298 16.0256 8.47613 15.8295 8.28011C15.6488 8.09431 15.4287 7.95132 15.1855 7.8616C14.9879 7.78472 14.6916 7.69359 14.1453 7.66864ZM11.1669 13.9539C11.5664 14.1202 12.0112 14.1426 12.4254 14.0174C12.8396 13.8922 13.1975 13.627 13.4379 13.2672C13.6784 12.9074 13.7864 12.4753 13.7436 12.0447C13.7009 11.6141 13.5099 11.2117 13.2034 10.9062C13.008 10.711 12.7718 10.5614 12.5117 10.4684C12.2516 10.3754 11.9741 10.3413 11.6992 10.3684C11.4243 10.3955 11.1588 10.4832 10.9219 10.6253C10.685 10.7673 10.4825 10.9601 10.329 11.1897C10.1755 11.4194 10.0749 11.6803 10.0343 11.9535C9.99376 12.2267 10.0143 12.5056 10.0944 12.7699C10.1745 13.0343 10.3123 13.2776 10.4977 13.4823C10.6832 13.687 10.9117 13.8481 11.1669 13.9539ZM9.8467 10.1919C10.114 9.9246 10.4313 9.71256 10.7806 9.5679C11.1299 9.42323 11.5042 9.34877 11.8822 9.34877C12.2602 9.34877 12.6346 9.42323 12.9838 9.5679C13.3331 9.71256 13.6504 9.9246 13.9177 10.1919C14.185 10.4592 14.3971 10.7766 14.5417 11.1258C14.6864 11.4751 14.7609 11.8494 14.7609 12.2274C14.7609 12.6055 14.6864 12.9798 14.5417 13.329C14.3971 13.6783 14.185 13.9956 13.9177 14.263C13.3779 14.8028 12.6457 15.1061 11.8822 15.1061C11.1187 15.1061 10.3865 14.8028 9.8467 14.263C9.30684 13.7231 9.00356 12.9909 9.00356 12.2274C9.00356 11.464 9.30684 10.7318 9.8467 10.1919ZM15.3993 9.77748C15.4656 9.71499 15.5186 9.63985 15.5553 9.5565C15.5919 9.47315 15.6115 9.38329 15.6129 9.29224C15.6142 9.20118 15.5972 9.11079 15.563 9.02641C15.5288 8.94202 15.4779 8.86537 15.4136 8.80098C15.3492 8.73659 15.2725 8.68577 15.1881 8.65153C15.1037 8.6173 15.0133 8.60035 14.9223 8.60167C14.8312 8.603 14.7414 8.62258 14.658 8.65926C14.5747 8.69594 14.4995 8.74897 14.4371 8.81521C14.3155 8.94404 14.249 9.11515 14.2516 9.29224C14.2542 9.46932 14.3257 9.63842 14.4509 9.76365C14.5761 9.88888 14.7452 9.96037 14.9223 9.96295C15.0994 9.96554 15.2705 9.899 15.3993 9.77748Z"
                        fill="white"
                      />
                    </g>
                    <circle
                      cx="11.882"
                      cy="12.2277"
                      r="10.7101"
                      stroke="white"
                      stroke-width="2"
                    />
                    <defs>
                      <clipPath id="clip0_342_1622">
                        <rect
                          width="12.2192"
                          height="12.2192"
                          fill="white"
                          transform="translate(5.77246 6.11914)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li> */}

              {/* <li>
                <a href="javascript:void(0)">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_342_1622)">
                      <path
                        d="M216.856339,16.5966031 C200.285002,8.84328665 182.566144,3.2084988 164.041564,0 C161.766523,4.11318106 159.108624,9.64549908 157.276099,14.0464379 C137.583995,11.0849896 118.072967,11.0849896 98.7430163,14.0464379 C96.9108417,9.64549908 94.1925838,4.11318106 91.8971895,0 C73.3526068,3.2084988 55.6133949,8.86399117 39.0420583,16.6376612 C5.61752293,67.146514 -3.4433191,116.400813 1.08711069,164.955721 C23.2560196,181.510915 44.7403634,191.567697 65.8621325,198.148576 C71.0772151,190.971126 75.7283628,183.341335 79.7352139,175.300261 C72.104019,172.400575 64.7949724,168.822202 57.8887866,164.667963 C59.7209612,163.310589 61.5131304,161.891452 63.2445898,160.431257 C105.36741,180.133187 151.134928,180.133187 192.754523,160.431257 C194.506336,161.891452 196.298154,163.310589 198.110326,164.667963 C191.183787,168.842556 183.854737,172.420929 176.223542,175.320965 C180.230393,183.341335 184.861538,190.991831 190.096624,198.16893 C211.238746,191.588051 232.743023,181.531619 254.911949,164.955721 C260.227747,108.668201 245.831087,59.8662432 216.856339,16.5966031 Z M85.4738752,135.09489 C72.8290281,135.09489 62.4592217,123.290155 62.4592217,108.914901 C62.4592217,94.5396472 72.607595,82.7145587 85.4738752,82.7145587 C98.3405064,82.7145587 108.709962,94.5189427 108.488529,108.914901 C108.508531,123.290155 98.3405064,135.09489 85.4738752,135.09489 Z M170.525237,135.09489 C157.88039,135.09489 147.510584,123.290155 147.510584,108.914901 C147.510584,94.5396472 157.658606,82.7145587 170.525237,82.7145587 C183.391518,82.7145587 193.761324,94.5189427 193.539891,108.914901 C193.539891,123.290155 183.391518,135.09489 170.525237,135.09489 Z"
                        fill="white"
                      ></path>
                    </g>

                    <defs>
                      <clipPath id="clip0_342_1622">
                        <rect
                          width="12.2192"
                          height="12.2192"
                          fill="white"
                          transform="translate(5.77246 6.11914)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li> */}
            {/* </ul>
          </div> */}

          <div className="nft-gif">
            {/* <div className="whitelogo-here">
              <img src="images/whitelogo.png" alt="" className="img-fluid" />
            </div> */}
            {/* <img src="images/RRCHeadQuarters-Exterior.jpg" alt="" className="img-fluid" /> */}
            <div className="enter-wrap position-relative">
              <div className="enter-btn-part">
                {/* <h1>Welcome To The </h1>
                <h3>ROBOTIC RABBIT SYNDICATE </h3> */}
                <Button className="enter-btn" onClick={() => navigate("/home")}>
                   Proceed
                </Button>
              </div>
              {/* <div className="animated-text">
                <p>
                  <svg width="22" height="22" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="m10.875 19.3l-6.6-6.6q-.15-.15-.213-.325Q4 12.2 4 12t.062-.375q.063-.175.213-.325l6.6-6.6q.275-.275.687-.288q.413-.012.713.288q.3.275.313.687q.012.413-.288.713L7.4 11h11.175q.425 0 .713.287q.287.288.287.713t-.287.712Q19 13 18.575 13H7.4l4.9 4.9q.275.275.288.7q.012.425-.288.7q-.275.3-.7.3q-.425 0-.725-.3Z"
                    />
                  </svg>
                  scroll down
                </p>
              </div> */}
            </div>
          </div>
          {/* <div className="text-center px-3 w-100">
            <img src="/images/logo.png" alt="" className="img-fluid mt-4" />
          </div> */}
        </div>
      </Container>
    </section>
  );
}
